module.exports = __webpack_public_path__ + "images/no-image-placeholder-small-4bac209f.svg";